import {
  DeleteOutlined,
  EditOutlined,
  ExportOutlined,
  ImportOutlined,
  MoreOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import type { MenuProps } from "antd";
import { ModalDelete } from "src/components/ModalDelete";
import { t } from "i18next";
import { bom3ControlStore as store } from "./Bom3ControlStore";
import { Bom3StatesModal } from "./Bom3StatesModal";

export const Bom3Actions: React.FC = observer(() => {
  const { selectedRows, msgEdit, msgDelete } = store;

  const items: MenuProps["items"] = [
    {
      key: "changeState",
      label: "Смена состояния",
      icon: <RetweetOutlined />,
      disabled: !store.canChangeState,
      title: store.changeStateMsg,
      onClick: () => store.setStateMode(true),
    },
    {
      key: "copyTo",
      label: t("Copy to"),
      icon: <ExportOutlined />,
      disabled: !store.canCopyIn,
      title: store.copyInMsg,
      onClick: () => store.startCopyIn(),
    },
    {
      key: "Copy from",
      label: t("Copy from"),
      icon: <ImportOutlined />,
      onClick: () => store.startCopyFrom(),
    },
    {
      key: "edit",
      label: "Редактировать",
      icon: <EditOutlined />,
      title: msgEdit,
      disabled: !!msgEdit,
      onClick: () => store.onEdit(selectedRows[0]!),
    },
    {
      key: "delete",
      label: "Удалить",
      icon: <DeleteOutlined />,
      danger: true,
      disabled: !!msgDelete,
      title: msgDelete,
      onClick: () => store.setDeleteIds(selectedRows.map(({ id }) => id)),
    },
  ];
  return (
    <>
      <Dropdown menu={{ items }}>
        <Button icon={<MoreOutlined />} />
      </Dropdown>
      <ModalDelete
        open={store.deleteIds.length > 0}
        message="Данные будут удалены без возможности восстановления."
        onOk={() => store.doDelete()}
        onCancel={() => store.setDeleteIds([])}
        waiting={store.task === "delete"}
      />
      <Bom3StatesModal />
    </>
  );
});
